// The overdue banner (laravel billing/notice, App\Overdue): what it says to the company admin (with the amount and
// Pay now) and to its district managers (a short version without amounts), and how it looks.

// The banner's text for a notice from the server; '' when there is none
export function overdueText(notice, level) {
	if (!notice) {
		return '';
	}
	const companyAdmin = level === 'c';
	const invoice = 'Invoice ' + notice.number + (companyAdmin && notice.total_usd ? ' (USD ' + notice.total_usd + ')' : '');
	if (notice.stopped) {
		return companyAdmin
			? 'Mobiliis is suspended because invoice ' + notice.number + (notice.total_usd ? ' (USD ' + notice.total_usd + ')' : '')
				+ ' is unpaid. It will be reinstated as soon as the payment is received.'
			: 'Mobiliis is suspended because invoice ' + notice.number + ' is unpaid. Please ask your company admin to pay it.';
	}
	const ask = companyAdmin ? 'Please pay' : 'Please ask your company admin to pay it';
	return invoice + ' is overdue. ' + ask + (notice.stop_label ? ' to avoid suspension on ' + notice.stop_label + '.' : ' as soon as possible.');
}

// Mobiliis colours until the 2nd reminder's day (the server's tone "warning"), then red
export function overdueClass(notice) {
	return notice && notice.tone === 'danger' ? 'alert alert-danger' : 'alert overdue-banner-mobiliis';
}

// Who sees the banner: the company admin and its district managers
export function seesOverdueBanner(level) {
	return level === 'c' || level === 'd';
}
